import React from "react";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <p>Designed and Developed by Shibil Khan</p>
      </div>
      <div className="footer-center">
        <p>Copyright © 2025 SK</p>
      </div>
      <div className="footer-right">
        <a href="https://github.com/Shibilkhan999" target="_blank" rel="noreferrer">
          <AiFillGithub />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noreferrer">
          <AiOutlineTwitter />
        </a>
        <a href="https://www.linkedin.com/in/shibil-khan-/" target="_blank" rel="noreferrer">
         <FaLinkedinIn />

        </a>
        <a href="https://www.instagram.com/shibilkhan.official" target="_blank" rel="noreferrer">
          <AiFillInstagram />
        </a>
      </div>
    </footer>
  );
};

export default Footer;